// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","186":"company","245":"notfound","631":"contact","894":"services"}[chunkId] + "-legacy." + {"176":"a2e77f08","186":"1396a81f","245":"a64ff3d5","631":"f73d74a4","894":"6bf329c9"}[chunkId] + ".js";
};